import React from "react";
import BlocBuilder from "bloc-builder-react";
import { motion, AnimateSharedLayout, AnimatePresence } from "framer-motion";
import { Swiper, SwiperSlide } from 'swiper/react';
import InfoSpot from "../InfoSpot";
import BottomModal from "../BottomModal/BottomModal";
import SwipeScreen from "../../../SwipeScreen";
import $ from "jquery";
import RoomTopActions from "../RoomComponent/RoomTopActions";
import SwiperCore, { Navigation, Pagination } from "swiper";
import MuseumRoomBloc from "../../blocs/MuseumRoomBloc";
import GalleryScreen from "./GalleryScreen";
import TapToCloseArea from "../RoomComponent/TapToCloseArea";
import BottomModalState from "../../models/BottomModalState";
import $events from "../../blocs/EventBloc";
import { f } from "../../../_f";

export default class MuseumRoom extends React.Component {
    constructor( props ) {
        super(props);
        this.bloc           = new MuseumRoomBloc(props.roomState);
        this.swipeScreenRef = React.createRef();
    }

    componentDidMount() {
        new SwipeScreen($(this.swipeScreenRef.current));
    }

    openGallery = ( e, gallery ) => {
        e.preventDefault();
        e.stopPropagation();

        this.bloc.openGallery(gallery);
    };

    restartHouse = ( e ) => {
        e.preventDefault();
        e.stopPropagation();
        $events.$emit('tutorial/skip');
    };

    get pointerString() {
        return f.isTouchDevice ? 'Tippe' : 'Klicke';
    }

    render() {
        SwiperCore.use([Navigation, Pagination]);
        let roomState = this.props.roomState;

        return (
            <BlocBuilder
                subject={this.bloc.getSubject()}
                builder={( snapshot ) => {
                    let museumState = snapshot.data;

                    return <AnimateSharedLayout type="crossfade">
                        <div className="museum-room">
                            <div className="museum-room-main">
                                <div className="museum-room__top">
                                    <div className={`swipe-screen  [ museum-screen ]  [ js-swipe-screen ]`}
                                         data-static-mode="cover"
                                         ref={this.swipeScreenRef}>

                                        <div className="swipe-screen__top-actions">
                                            <div className="swipe-screen__top-action  action--restart"
                                                 onClick={( ev ) => this.restartHouse(ev)}>

                                                <div className="icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -51.8555 22.207 27.0703">
                                                        <path
                                                            d="M10.6641,-39.3164q-0.996094,0 -0.996094,-0.996094q0,-0.410156 0.292969,-0.703125l3.75,-3.75q-0.996094,-0.234375 -2.63672,-0.234375q-3.80859,0 -6.44531,2.63672q-2.63672,2.63672 -2.63672,6.44531q0,3.80859 2.63672,6.44531q2.63672,2.63672 6.44531,2.63672q3.80859,0 6.44531,-2.63672q2.63672,-2.63672 2.63672,-6.44531q0,-1.05469 0.996094,-1.05469q1.05469,0 1.05469,1.05469q0,4.62891 -3.25195,7.88086q-3.25195,3.25195 -7.88086,3.25195q-4.62891,0 -7.85156,-3.25195q-3.22266,-3.25195 -3.22266,-7.88086q0,-4.62891 3.22266,-7.85156q3.22266,-3.22266 7.85156,-3.22266q1.11328,0 2.16797,0.175781l-3.33984,-3.28125q-0.234375,-0.234375 -0.234375,-0.703125q0,-1.05469 0.9375,-1.05469q0.46875,0 0.761719,0.292969l5.15625,5.27344q0.351562,0.351562 0.351562,0.761719q0,0.410156 -0.351562,0.761719l-5.15625,5.15625q-0.292969,0.292969 -0.703125,0.292969Z"
                                                            fill="currentColor"></path>
                                                    </svg>
                                                </div>

                                                <div className="label">
                                                    Rundgang <br/>
                                                    neustarten
                                                </div>

                                            </div>
                                        </div>

                                        <div className="swipe-screen__background-container  [ js-swipe-screen-bg ]"
                                             data-offset-x="0" data-offset-y="0">

                                            <div className="swipe-screen__background">
                                                <div className="swipe-screen__image">
                                                    <img src={( roomState?.room?.thumbnailUrl ?? '' )}
                                                         alt={( roomState?.room?.title ?? '' )}/>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="swipe-screen__foreground  [ museum-screen__foreground ]">
                                            <h3 className="page__subtitle  [ margin__bottom--small ]">
                                                {roomState?.room?.title ?? ''}
                                            </h3>

                                            <div className="copy  [ museum-screen__room-desc ]"
                                                 dangerouslySetInnerHTML={{ __html: roomState?.room?.content ?? '' }}></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="museum-room__bottom">
                                    <Swiper
                                        className="margin__bottom--xsmall"
                                        navigation={{
                                            prevEl: '.prev',
                                            nextEl: '.next'
                                        }}
                                        loop={false}
                                        spaceBetween={10}
                                        slidesPerView={1.2}
                                        breakpoints={{
                                            "671": {
                                                "slidesPerView": 1.5,
                                            },
                                            "1024": {
                                                "slidesPerView": 2.3,
                                            },
                                            "1261": {
                                                "slidesPerView": 3.4,
                                            }
                                        }}
                                        onSlideChange={() => console.log('slide change')}
                                        onSwiper={( swiper ) => console.log(swiper)}
                                    >
                                        {roomState?.room?.museum_fields?.galleries?.map(( gallery, i ) =>
                                            <SwiperSlide>
                                                <div class="room-overview__room  [ museum-room__gallery ]  pointer"
                                                     onClick={( ev ) => this.openGallery(ev, gallery)}>
                                                    <motion.div
                                                        layoutId={`gallery-thumb-${gallery.gallery_title}`}
                                                        className={`room-switch__image`}>
                                                        {( typeof gallery.gallery_thumbnail !== 'undefined' ) &&
                                                        <img
                                                            title={`gallery-thumb-${gallery.gallery_title}`}
                                                            src={gallery.gallery_thumbnail?.sizes?.medium ?? ''} alt={gallery.gallery_title}/>
                                                        }

                                                        <div class="room-switch__image-title">
                                                            <div>
                                                                <div className="margin__bottom--xsmall">{gallery.gallery_title}</div>
                                                                {( typeof gallery.gallery_desc !== 'undefined' && gallery.gallery_desc !== '' ) &&
                                                                <div className="meta  color--grey-200">
                                                                    {gallery.gallery_desc}
                                                                </div>}
                                                            </div>
                                                        </div>
                                                    </motion.div>
                                                </div>
                                            </SwiperSlide>
                                        )}
                                        <div className="swiper-arrow  arrow-prev  prev"/>
                                        <div className="swiper-arrow  arrow-next next"/>
                                    </Swiper>

                                    <div className="meta  color--grey-400">
                                        {this.pointerString} auf eine Galerie, um sie zu erkunden.
                                    </div>
                                </div>
                            </div>

                            <AnimatePresence>
                                <GalleryScreen
                                    isOpen={museumState?.isOpen ?? false}
                                    gallery={museumState?.currentGallery ?? null}
                                    museumBloc={this.bloc}
                                    roomBloc={this.props.roomBloc}
                                    roomState={roomState}>
                                </GalleryScreen>
                            </AnimatePresence>

                        </div>
                    </AnimateSharedLayout>;
                }} >
            < /BlocBuilder>
        );
    }

}
